import DashboardIcon from "@mui/icons-material/Dashboard";
import BarChartIcon from "@mui/icons-material/BarChart";
import FolderIcon from "@mui/icons-material/Folder";
import SettingsIcon from "@mui/icons-material/Settings";
import type { SvgIconComponent } from "@mui/icons-material";

export const DRAWER_WIDTH = 256;

export interface NavItem {
  path: string;
  i18nKey: string;
  icon: SvgIconComponent;
  requiresAuth: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  {
    path: "/dashboard",
    i18nKey: "nav.dashboard",
    icon: DashboardIcon,
    requiresAuth: true,
  },
  {
    path: "/metrics",
    i18nKey: "nav.metrics",
    icon: BarChartIcon,
    requiresAuth: true,
  },
  {
    path: "/projects",
    i18nKey: "nav.projects",
    icon: FolderIcon,
    requiresAuth: true,
  },
  {
    path: "/account",
    i18nKey: "nav.account",
    icon: SettingsIcon,
    requiresAuth: true,
  },
];
